<template>
  <div>
    <span v-if="successMessage" class="success-message">✓ Zapisano</span>
    <div
      :class="mthClassByText(text)"
      v-if="!editmode"
      @click="mthSwitchToEditMode"
      v-html="compTextOrPlaceholder"
      :key="key"
    ></div>
  
    <!-- html -->
    <button
      v-if="editmode && html"
      @click="mthSaveModifiedData({ text: text })"
    >
      Zapisz
    </button>
    <button
      class="ml-3 mb-1"
      v-if="editmode && html"
      @click="mthSaveModifiedData({ text: text }, true)"
    >
      (!)Zapisz bez html
    </button>
    <vue-editor
      v-model="text"
      v-if="editmode && html"
      @blur="mthSwitchToReadOnly"
      @text-changed="mthSaveModifiedData($event)"
    ></vue-editor>

    <!-- plain text -->
    <textarea
      v-focus
      v-autoresize
      v-if="editmode && !html"
      v-model="text"
      @blur="mthSwitchToReadOnly"
      @keyup.shift.enter="mthSaveModifiedData($event)"
      @keyup.ctrl.enter="mthSaveModifiedData($event)"
      @keyup.esc="mthSwitchToReadOnly"
      style="width: 100%"
      title="Naciśnij Shift + Enter, aby zapisać"
    />
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  props: ["textinl", "idpk"],
  data() {
    return {
      editmode: false,
      html: false,
      text: "",
      key: 0,
      successMessage: false,
    };
  },
  components: { VueEditor },
  created() {
    this.text = this.textinl ? this.textinl.trim().replace(/\n/g, "<br />") : "";
    //console.log("idpk=" + this.idpk);
  },
  computed: {
    compTextOrPlaceholder() {
      let text = this.text.trim();
      if (text == "" || text == null || (text != `` && this.mthSanitizeHTML(text) == ``))
        return "(pole jest puste, kliknij aby edytować(5))";
      return text.trim().replace(/\n/g, "<br />");
    },
  },
  methods: {
    mthTextOrPlaceholder(text) {
      if (text == "" || text == null)
        return "(pole jest puste, kliknij aby edytować(6))";
      return text.trim();
    },
    mthClassByText(text) {
      if (text == "" || text == null) return "empty";
      return "";
    },
    mthPlaceholderForEmptyValue(value) {
      //if value is empty, there is no place to click for edit...
      console.log('value: ', value);
      if (value == "") return "(pole jest puste, kliknij aby edytować(7))";
      return "";
    },
    mthSwitchToEditMode() {
      if(this.textinl != null) this.text = this.textinl.trim();
      this.editmode = true;
      if (this.text.toUpperCase().includes(`<P>`) || this.text.toUpperCase().includes(`<HTML`)) this.html = true;
      else this.html = false;
    },
    mthSwitchToReadOnly() {
      this.editmode = false;
    },
    mthSanitizeHTML(t) {
      let doc = new DOMParser().parseFromString(t, "text/html");
      return doc.body.textContent || "";
    },
    mthSaveModifiedData(event, sanitizeHtml = false) {
      console.log('event: ', event);
      
      if(sanitizeHtml) event.text=this.mthSanitizeHTML(event.text);

      //event: native from textarea or {text: 'bla'} from vue2-editor

      var that = this;

      var apiurl =
        process.env.VUE_APP_API_URL +
        "/b2bsetattrvalfromtbl?tbln=lokalizacja" +
        "&key1n=id" +
        "&key1v=" +
        that.idpk +
        "&key2n=" +
        "&key2v=" +
        "&fieldn=text" +
        "&data=" +
        encodeURIComponent(this.text.trim()) +
        "&index=" +
        "&datatype=txt";

      const options = { method: "get", url: apiurl };
      this.$axios(options)
        .then(function (response) {
          that.editmode = false;
          that.key++;
          that.$emit("emitedChanged", event);
          if (response.data && response.data.success === true) {
            that.successMessage = true;
            setTimeout(() => {
              that.successMessage = false;
            }, 2000);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus();
      },
    },
  },
};
</script>

<style scoped>
input {
  width: 100%;
  background-color: yellow;
}
.empty {
  font-weight: bold;
  background-color: lightgray;
}
.success-message {
  display: inline-block;
  background-color: #4caf50;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.85em;
  margin-right: 8px;
  animation: fadeIn 0.3s ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>